const InternalDomains = ["williamslea.com"];

export { InternalDomains }